"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BsLazyRender = void 0;
const react_1 = __importDefault(require("react"));
const util_env_platform_1 = require("@hotelplan/util.env.platform");
const use_element_entered_viewport_1 = require("./use-element-entered-viewport");
const BsLazyRender = props => {
    const { className, children, placeholder = null, root, rootMargin = '50px', } = props;
    const { entered, refEl } = (0, use_element_entered_viewport_1.useElementEnteredViewport)({
        root,
        rootMargin,
        enable: !util_env_platform_1.isIE,
    });
    if (util_env_platform_1.isIE) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    if (!entered) {
        return (react_1.default.createElement("div", { ref: refEl, className: className, suppressHydrationWarning: true, dangerouslySetInnerHTML: { __html: '' } }));
    }
    return (react_1.default.createElement("div", { ref: refEl, className: className, suppressHydrationWarning: true }, entered ? children : placeholder));
};
exports.BsLazyRender = BsLazyRender;
//# sourceMappingURL=bs-lazy-render.js.map